/**
 * Which side of the work the caller's firm is on: the client's, the vendor's, or neither.
 *
 * The values are the names `Work.WorkAgreements.WorkContext` binds from a list URL.
 */
export enum WorkContext {
  Client = "Client",
  Vendor = "Vendor",
  None = "None",
}
